module.exports = __webpack_public_path__ + "static/005-25e8114ff3f468c7f8f7f7384577bcfd.jpg";